import React from "react";
import shoppingIc from "../assets/images/shoppingIC.png";
import shoppingIcok from "../assets/images/shoppingICok.png";
import discount from "../assets/images/discount.png";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../context/UserContext";
import { IoHeart } from "react-icons/io5";
import { IoIosHeartEmpty } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { getFetcher, postFetcher } from "../../api/fetchers";
import { endpoints } from "../../api/endpoints";
import { Tooltip } from "flowbite-react";
import { parseStatics } from "../function/parseStatics";
import { calculateDiscountedPrice } from "../utils/functions";
import { useCurrency } from "../context/CurrencyContext";
import { useLanguage } from "../context/LanguageContext";

interface IProps {
  product: any;
  type?: string;
  userBusinessPackage: any;
}

const ProductCart: React.FC<IProps> = ({ product, type, userBusinessPackage }) => {
  const { t } = useLanguage();
  const { exchangeRate, currencySymbol } = useCurrency();
  const navigate = useNavigate();
  const { user, isAuth } = useUser();
  const { addFavoriteProduct, removeFavoriteProduct } = useUser();
  const [favoriteProductIds, setFavoriteProductIds] = useState<Set<string>>(
    new Set()
  );
  const [retailStatus] = useState(localStorage.getItem('rst') == "6535" ? true : false);

  const handleClickAddToBasket = async (product: any) => {
    // @ts-ignore
    const localUserId = parseStatics(localStorage.getItem("defaultUserId"));
    let userId;

    if (user) {
      userId = user.id;
    } else if (localUserId) {
      userId = localUserId;
    } else {
      userId = "";
    }

    try {
      const response = await postFetcher(endpoints.user.addProductBasket, {
        arg: {
          userId,
          productId: product?.id,
          quantity: Number(1),
          attributes: {},
          bulkDiscount: 0,
          businessPackageId: user ? user.businessPackageId : "10",
        },
      });

      if (!localUserId && !user) {
        localStorage.setItem(
          "defaultUserId",
          JSON.stringify(response.basketItem.userId)
        );
      }

      if (response?.result) {
        toast.success(
          `${product?.name} ${t("toastMessage", "addBasketCartSuc")}`
        );
        //@ts-ignore
        const currentBasket: any = parseStatics(localStorage.getItem("basketItems")) || [];
        const updatedBasket: any = [...currentBasket, product?.id];
        localStorage.setItem("basketItems", JSON.stringify(updatedBasket));
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        t("toastMessage", "addBasketCartErr");
      }
    } catch (error) {
      console.error("Error adding product to basket:", error);
      toast.error(t("toastMessage", "addBasketCartErr"));
    }
  };

  const handleSelectAttributes = () => {
    toast.warning(t("toastMessage", "addBasketCartWarn"));
  };

  const fetchFavoriteProducts = useCallback(async (userId: string) => {
    try {
      const response = await getFetcher(
        `${endpoints.user.getFavorites}/${userId}`
      );
      if (response?.result) {
        const favoriteIds = response.favoriteProducts.map(
          (favoriteProduct: any) => favoriteProduct.productId
        );
        return favoriteIds;
      }
      return [];
    } catch (error) {
      console.error("Error fetching favorite products:", error);
      return [];
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      const getFavorites = async () => {
        const favoriteIds = await fetchFavoriteProducts(user.id);
        setFavoriteProductIds(new Set(favoriteIds));
      };

      getFavorites();
    }
  }, [user]);


  const toggleLike = useCallback(
    async (id: string, productName: string) => {
      const isLiked = favoriteProductIds.has(id);

      try {
        if (isLiked) {
          await removeFavoriteProduct(id);
          setFavoriteProductIds((prevIds) => {
            const newIds = new Set(prevIds);
            newIds.delete(id);
            return newIds;
          });
          toast.info(`${productName} removed from favorites`);
        } else {
          await addFavoriteProduct(id);
          setFavoriteProductIds((prevIds) => {
            const newIds = new Set(prevIds);
            newIds.add(id);
            return newIds;
          });
          toast.success(`${productName} added to favorites`);
        }
      } catch (error) {
        toast.error("Error updating favorite status");
      }
    },
    [favoriteProductIds]
  );

  return (
    <>
      <div className={`bg-white min-w-[190px] ${type == 'pcat' ? 'w-[270px] h-[360px]' : 'w-[250px] h-[320px]'} rounded-lg flex flex-col items-center p-4 gap-y-1  relative rounded-b-none rounded-br-lg bg-gradient-to-b from-[#fff] to-[#f1f1f1e8] hover:bg-gradient-to-b hover:from-[#FFE053] hover:to-[#FFD102] group transition-all duration-500 ease-out hover:rounded-bl-lg`}>
        {/* img */}
        <div
          className=" cursor-pointer"
          onClick={() => navigate(`/product-detail/${product?.id}`)}
        >
          <img
            src={product?.images[0]}
            alt="img0"
            className={`w-full h-auto ${type == 'pcat' ? 'min-h-[210px] max-h-[210px]' : 'min-h-[160px] max-h-[160px]'}  object-contain min-w-[190px]`}
          />
        </div>

        {/* name & brand */}
        <div
          onClick={() => navigate(`/product-detail/${product?.id}`)}
          className=" flex justify-between w-full flex-col items-start gap-y-1 min-h-[55px] cursor-pointer"
        >
          <p className="  text-[#141C3A] font-rubik font-[500]">
            {product?.name.length > 20 ? (
              <Tooltip content={product?.name} style="light">
                {product?.name.slice(0, 20)}...
              </Tooltip>
            ) : (
              product?.name
            )}
          </p>
          <div className=" flex justify-between w-full">
            <p className=" text-[#808080] text-[12px] font-normal font-rubik -mt-1">
              {product?.brand}
            </p>
            <p className=" text-[#808080] text-[12px] font-bold font-rubik -mt-1">
              #{product?.code}
            </p>
          </div>
        </div>

        {/* price */}
        {
          retailStatus ?
            <div className=" flex w-full justify-end font-bold flex-col items-end ">
              {false ? (
                // Skeleton loader for the price section
                <div className="flex flex-col items-end">
                  <div className="w-[70px] h-[20px] bg-gray-300 animate-pulse"></div>
                  <div className="w-[100px] h-[20px] bg-gray-300 animate-pulse mt-2"></div>
                </div>
              ) : (
                <>
                  {product?.discount ||
                    (userBusinessPackage && userBusinessPackage?.id !== "10") ? (
                    <span className="line-through text-red-900 text-sm font-rubik font-normal">
                      {currencySymbol}
                      {(product?.price * exchangeRate).toFixed(1)}
                    </span>
                  ) : null}
                  <div className=" text-[19px] text-[#141C3A] ">
                    {product?.discount ||
                      (userBusinessPackage && userBusinessPackage?.id !== "10") ? (
                      <span>
                        {currencySymbol}
                        {calculateDiscountedPrice(
                          product.price,
                          product.discount,
                          userBusinessPackage ? userBusinessPackage?.ratio : 0,
                          exchangeRate
                        )}
                      </span>
                    ) : (
                      <span>
                        {currencySymbol}
                        {calculateDiscountedPrice(
                          product.price,
                          product.discount,
                          userBusinessPackage ? userBusinessPackage?.ratio : 0,
                          exchangeRate
                        )}
                      </span>
                    )}
                  </div>
                </>
              )}
            </div>
            :
            <div className="flex w-full justify-end font-bold flex-col items-end">
              <p className="text-[12px] w-[150px] md:w-[100px] 2xl:w-[150px] mt-3 text-end" style={{ lineHeight: '1.2' }}>
                {t("general", "reqLog")}
              </p>

            </div>
        }

        {/* favorites */}
        <div className=" absolute right-2 top-2">
          {isAuth ? (
            <button
              className=""
              onClick={() => toggleLike(product?.id, product?.name)}
            >
              {favoriteProductIds.has(product.id) ? (
                <IoHeart className="text-primary-color text-3xl mt-2 mr-2" />
              ) : (
                <IoIosHeartEmpty className="text-primary-color text-3xl mt-2 mr-2" />
              )}
            </button>
          ) : (
            <button
              className=""
              onClick={() =>
                toast.warning(t("toastMessage", "addBasketLoginWar"))
              }
            >
              <IoIosHeartEmpty className="text-primary-color text-3xl mt-2 mr-2" />
            </button>
          )}
        </div>

        {/* add basket */}
        {Object.keys(product?.attributes || {}).length < 1 ? (
          <div
            onClick={() => {
              if (retailStatus)
                handleClickAddToBasket(product)
              else
                toast.error(t('general', 'reqLogBasket'));
            }}
            className="absolute -left-2 -bottom-2 bg-transparent rounded-r-lg rounded-b-none rounded-l-none p-2 transition-all group-hover:bg-transparent group-hover:rounded-bl-lg"
          >
            {(() => {
              const basketItems: any[] = parseStatics(
                localStorage.getItem("basketItems") || "[]"
              );

              if (basketItems.includes(product?.id)) {
                return (
                  <img
                    className="cursor-pointer w-[70px] h-[70px]"
                    src={shoppingIcok}
                    alt="shoppingIcok"
                  />
                );
              }

              return (
                <img
                  className="cursor-pointer w-[70px] h-[70px]"
                  src={shoppingIc}
                  alt="shoppingIc"
                />
              );
            })()}
          </div>
        ) : (
          <div
            onClick={() => {
              if (retailStatus)
                handleSelectAttributes()
              else
                toast.error(t('general', 'reqLogBasket'));
            }}
            className="absolute -left-2 -bottom-2 bg-transparent rounded-r-lg rounded-b-none rounded-l-none p-2 transition-all group-hover:bg-transparent group-hover:rounded-bl-lg"
          >
            <img
              className="cursor-pointer w-[70px] h-[70px]"
              src={shoppingIc}
              alt="shoppingIc"
            />
          </div>
        )}

        {/* discount */}
        {
          product?.discount ?
            <div className=" absolute -left-3 -top-2">
              <div className="relative w-14 h-14">
                <img className=" w-full h-full" src={discount} alt="discount" />
                <div className="absolute inset-0 flex justify-center items-center text-white font-bold text-sm transform -rotate-45">
                  {product?.discount}%
                </div>
              </div>
            </div>
            :
            <></>
        }
      </div>
    </>
  );
};

export default ProductCart;
